<template>
  <div>
    <div class="about">
      <div class="bannerTemp">
        <div class="module">
          <div class="line"></div>
          专业的空间信息可视化产品和服务提供商
          <div class="line"></div>
        </div>
      </div>
      <div class="intro">
        <div class="module">
          <titleTemp2 :data="introData"></titleTemp2>
          <div class="content">
            <div class="left">
              <div class="bg"></div>
              <div class="img"></div>
            </div>
            <div class="right">
              <p>
                上海臻图信息技术有限公司是一家专注于空间信息二三维可视化产品研发和应用建设的科技企业。公司研发团队在十数年的技术沉淀和积累的基础上，坚持自主创新，研发出一系列具有自主知识产权的空间信息二三维可视化产品。以三维融合渲染平台、VR实景三维平台、GIS平台为代表的核心产品，以应用为导向，专于GIS、BIM、VR、AR等信息可视化相关核心技术领域，在三维可视化深度应用、海量数据轻量化渲染、跨领域融合渲染、高效率应用开发、VR三维建模等方面，具备独特特点和优势。
              </p>
              <p>
                臻图信息坚持自主技术创新，依托核心产品，深入研究行业应用，在智慧城市、物联网领域不断深耕细作，以空间信息可视化和时空大数据分析的创新视角为智慧城市信息化建设赋能。形成了智慧园区、智慧社区、智慧安防、智能建筑、智慧安全、智慧市政、智慧旅游等众多典型行业的智慧应用解决方案。并以精益求精、实干高效的工作精神，为众多政府事业及企业客户成功实施了若干大中型项目。
              </p>
              <p>
                臻图信息以技术创新为导向，致力于为客户创造价值，为社会贡献才智，开拓进取，务实笃行，打造空间信息可视化服务领导品牌。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="culture">
        <titleTemp2 :data="cultureData"></titleTemp2>
        <div class="module">
          <div class="list">
            <div>
              <span>定位</span>
              <p>专业的空间信息可视化产品和服务提供商</p>
            </div>
            <div>
              <span>使命</span>
              <p>让空间信息可视化应用更简单</p>
            </div>
            <div>
              <span>愿景</span>
              <p>成为国内领先的空间信息可视化服务提供商</p>
            </div>
            <div>
              <span>文化</span>
              <p>诚信、创新、负责、实干</p>
            </div>
          </div>
        </div>
      </div>
      <div class="qualification">
        <titleTemp2 :data="qualificationData"></titleTemp2>
        <div class="module">
          <div>
            <p>上海市高新技术企业</p>
            <p>(2020年11月12日-2023年11月11日)</p>
          </div>
          <div>
            <p>上海市软件企业</p>
            <p>(2023年12月31日-2024年12月30日)</p>
          </div>
          <div>
            <p>质量管理体系认证</p>
            <p>(2024年04月08日-2027年04月07日)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-about">
      <div class="mobile-banner">
        <p>专业的空间信息可视化<br>产品和服务提供商</p>
      </div>
      <div class="about-content">
        <div class="profile">
          <div class="part-title">公司简介</div>
          <div class="en-title">PROFILE</div>
          <div class="content">
            <div class="images">
              <img src="../assets/images/about/about_bg.png" class="image1" alt="">
              <img src="../assets/images/about/about_img.jpg" class="image2" alt="">
            </div>
            <div class="span-group">
              <p>上海臻图信息技术有限公司是一家专注于空间信息二三维可视化产品研发和应用建设的科技企业。公司研发团队在十数年的技术沉淀和积累的基础上，坚持自主创新，研发出一系列具有自主知识产权的空间信息二三维可视化产品。以三维融合渲染平台、VR实景三维平台、GIS平台为代表的核心产品，以应用为导向，专于GIS、BIM、VR、AR等信息可视化相关核心技术领域，在三维可视化深度应用、海量数据轻量化渲染、跨领域融合渲染、高效率应用开发、VR三维建模等方面，具备独特特点和优势。</p>
            </div>
          </div>
          <div class="other-content">
            <p>臻图信息坚持自主技术创新，依托核心产品，深入研究行业应用，在智慧城市、物联网领域不断深耕细作，以空间信息可视化和时空大数据分析的创新视角为智慧城市信息化建设赋能。形成了智慧园区、智慧社区、智慧安防、智能建筑、智慧安全、智慧市政、智慧旅游等众多典型行业的智慧应用解决方案。并以精益求精、实干高效的工作精神，为众多政府事业及企业客户成功实施了若干大中型项目。</p>
            <p>臻图信息以技术创新为导向，致力于为客户创造价值，为社会贡献才智，开拓进取，务实笃行，打造空间信息可视化服务领导品牌。</p>
          </div>
        </div>
        <div class="culture">
          <div class="part-title">公司文化</div>
          <div class="en-title">CULTURE</div>
          <div class="list">
            <div class="item">
              <span>定位</span>
              <p>专业的空间信息可视化产品和服务提供商</p>
            </div>
            <div class="item">
              <span>使命</span>
              <p>让空间信息可视化应用更简单</p>
            </div>
            <div class="item">
              <span>愿景</span>
              <p>成为国内领先的空间信息可视化服务提供商</p>
            </div>
            <div class="item">
              <span>文化</span>
              <p>诚信、创新、负责、实干</p>
            </div>
          </div>
        </div>
        <div class="qualification">
          <div class="part-title">荣誉资质</div>
          <div class="en-title">QUALIFICATION</div>
          <div class="container">
            <div class="item">
              <img src="../assets/images/about/about1.png" alt="">
              <p>上海市高新技术企业</p>
              <span>(2020年11月12日-2023年11月11日)</span>
            </div>
            <div class="item">
              <img src="../assets/images/about/about2.png" alt="">
              <p>上海市软件企业</p>
              <span>(2023年12月31日-2024年12月30日)</span>
            </div>
            <div class="item">
              <img src="../assets/images/about/about3.png" alt="">
              <p>质量管理体系认证</p>
              <span>(2024年04月08日-2027年04月07日)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "About",
  metaInfo: {
    title: "关于我们-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "臻图信息,臻图科技"
      },
      {
        name: "description",
        content: "公司简介,公司使命,公司愿景公司文化,联系方式。"
      }
    ]
  },
  // metaInfo: {
  //   title: "demo",
  //   titleTemplate: "%s - by vue-meta",
  //   htmlAttrs: {
  //     lang: "zh"
  //   },
  //   script: [
  //     { innerHTML: 'console.log("hello hello!")', type: "text/javascript" }
  //   ],
  //   meta: [
  //     { keywords: "utf-8" },
  //     {
  //       name: "viewport",
  //       content:
  //         "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"
  //     }
  //   ],
  //   __dangerouslyDisableSanitizers: ["script"]
  // },
  data() {
    return {
      bannerData: {
        title: "关于我们",
        p: ""
      },
      introData: {
        title: "公司简介",
        subtitle: "PROFILE"
      },
      cultureData: {
        title: "公司文化",
        subtitle: "CULTURE"
      },
      qualificationData: {
        title: "荣誉资质",
        subtitle: "QUALIFICATION"
      }
    };
  },
  methods: {},
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/about/banner.jpg");
  overflow: hidden;
  > div {
    margin-top: 224px;
    text-align: center;
    .line {
      display: inline-block;
      width: 100px;
      height: 2px;
      background: #fff;
      vertical-align: middle;
      margin: 0 20px;
    }
    font-size: 38px;
    line-height: 38px;
    color: rgba(255, 255, 255, 1);
  }
}
.about {
  .intro {
    padding: 100px 0;
    .content {
      overflow: hidden;
      margin-top: 60px;
    }
    .left {
      width: 400px;
      height: 400px;
      position: relative;
      float: left;
      .bg {
        width: 350px;
        height: 350px;
        background: url("../assets/images/about/about_bg.png") no-repeat center
          center / 100%;
      }
      .img {
        width: 350px;
        height: 350px;
        background: url("../assets/images/about/about_img.jpg") no-repeat center
          center / 100%;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .right {
      float: right;
      width: 728px;
      p {
        font-size: 16px;
        color: rgba(124, 124, 124, 1);
        line-height: 32px;
        text-indent: 32px;
      }
    }
  }
  .culture {
    background: #f8f8f8;
    padding: 40px 0 80px 0;
    .list {
      font-size: 0;
      > div {
        width: 282px;
        height: 180px;
        background: #69c0ff;
        display: inline-block;
        vertical-align: top;
        border-radius: 10px 50px 10px 10px;
        margin-right: 20px;
        margin-top: 80px;
        position: relative;
        > span {
          width: 70px;
          height: 70px;
          background: #fff;
          border-radius: 35px;
          font-size: 20px;
          display: inline-block;
          position: absolute;
          top: -35px;
          left: 40px;
          text-align: center;
          line-height: 70px;
          color: #69c0ff;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        }
        > p {
          width: 202px;
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          line-height: 24px;
          margin: 70px 0 0 40px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .qualification {
    padding: 100px 0 150px 0;
    .module {
      font-size: 0;
      padding-top: 36px;
      > div {
        display: inline-block;
        width: 241px;
        height: 231px;
        margin-right: 238px;
        position: relative;
        p:first-child {
          position: absolute;
          left: 0;
          bottom: 0px;
          height: 50px;
          font-size: 20px;
          color: rgba(75, 75, 75, 1);
          line-height: 50px;
          text-align: center;
          margin: 0;
          width: 100%;
        }
        p:last-child {
          position: absolute;
          left: 0;
          font-size: 14px;
          color: rgba(75, 75, 75, 1);
          line-height: 20px;
          text-align: center;
          margin: 0;
          bottom: -10px;
          height: 20px;
          width: 100%;
        }
        &:nth-child(1) {
          background: url("../assets/images/about/about1.png") no-repeat top
            center/232px 183px;
        }
        &:nth-child(2) {
          background: url("../assets/images/about/about2.png") no-repeat top
            center/232px 183px;
        }
        &:nth-child(3) {
          background: url("../assets/images/about/about3.png") no-repeat top
            center/232px 183px;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
.mobile-about {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-banner {
    width: 100%;
    background-image: url("../assets/images/about/banner.jpg");
    background-position: 50%;
    background-size: cover;
    height: 28rem;
    color: #fff;
    font-size: 1.8rem;
    font-weight: bold;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  .about-content {
    width: 100%;
    .profile {
      box-sizing: border-box;
      padding: 2rem;
      text-align: center;
      font-family: 'Normal';
      .part-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999;
      }
      .content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .images {
          width: 17rem;
          position: relative;
          flex-shrink: 0;
          img{
            margin-top: 2rem;
            width: 15rem;
            height: 100%;
            object-fit: contain;
          }
          .image1 {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-60%);
          }
          .image2 {
            position: absolute;
            top: 50%;
            left: 2rem;
            transform: translateY(-50%);
          }
        }
        .span-group {
          margin-left: 1rem;
          font-size: 1rem;
          line-height: 1.5rem;
          color: #333;
          text-align: left;
          >p {
            text-indent: 2em;
          }
        }
      }
      .other-content {
        width: 100%;
        font-size: 1rem;
        line-height: 1.5rem;
        color: #333;
        text-align: left;
        >p {
          margin: 0.5rem;
          text-indent: 2em;
        }
      }
    }
    .culture {
      box-sizing: border-box;
      padding: 2rem;
      text-align: center;
      font-family: 'Normal';
      background: rgba(0, 0, 0, 0.03);
      .part-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999;
      } 
      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 2rem;
        .item {
          width: 16rem;
          height: 11rem;
          box-sizing: border-box;
          font-size: 1rem;
          background: #69c0ff;
          display: inline-block;
          vertical-align: top;
          border-radius: 1rem 4.5rem 1rem 1rem;
          line-height: 11rem;
          color: #fff;
          position: relative;
          margin-top: 2rem;
          > span {
            width: 4rem;
            height: 4rem;
            background: #fff;
            border-radius: 50%;
            font-size: 1.3rem;
            display: inline-block;
            position: absolute;
            top: -1.5rem;
            left: 2rem;
            text-align: center;
            line-height: 4rem;
            color: #69c0ff;
            box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
          }
          > p {
            width: 80%;
            font-size: 1rem;
            color: rgba(255, 255, 255, 1);
            line-height: 1.5rem;
            text-align: left;
            margin: 4.5rem 0 0 2rem;
          }
        }
      }
    }
    .qualification {
      box-sizing: border-box;
      padding: 2rem;
      text-align: center;
      font-family: 'Normal';
      .part-title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        color: #333;
      }
      .en-title {
        font-size: 1.4rem;
        font-weight: 350;
        line-height: 2rem;
        color: #999;
      }
      .container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
        .item {
          width: 30%;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #333;
          img{
            width: 100%;
            object-fit: contain;
          }
          p {
            font-size: 1.1rem;
          }
          span {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .about {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-about { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue